export function profileInitials(displayName: string | undefined, email: string | undefined) {
  const words = displayName?.trim().split(/\s+/).filter(Boolean) ?? [];
  if (words.length > 0) {
    return `${words[0]?.[0] ?? ""}${words.length > 1 ? (words.at(-1)?.[0] ?? "") : ""}`.toUpperCase();
  }
  return email?.trim().slice(0, 2).toUpperCase() || "ME";
}

export function validateDisplayName(value: string) {
  const displayName = value.trim().replace(/\s+/g, " ");
  if (!displayName) return { error: "Enter your name." } as const;
  if (displayName.length > 200) return { error: "Name must be 200 characters or fewer." } as const;
  return { displayName } as const;
}
